import {createSelector} from 'reselect';
import {getCombinedData} from '../../utils/statsUtils';
import { sortBy } from 'lodash';

export const getAllAreas = (state) => {
  return state.dsaConfig && state.dsaConfig.areas || [];
};

export const getDSAAreas = (state) => {
  return state.dsa && state.dsa.dsaAreas || [];
};

export const getSubAreas = (state) => {
  return state.dsaConfig && state.dsaConfig.subAreas || [];
};

export const getOrderedSubAreas = createSelector(
  [getSubAreas],
  subAreas => sortBy(subAreas, ['area', 'order'])
);

// requires 'area' defined in props
const getArea = (state, props) => {
  return props && props.area;
};

export const makeGetActiveAreas = () => {
  return createSelector(
    [getAllAreas, getDSAAreas],
    (areas, dsaAreas) => {
      let combinedAreas = getCombinedData(areas, dsaAreas, 'area');
      let sortedAreas = combinedAreas.sort((a, b) => a.order - b.order);
      return sortedAreas.filter(a => a.active);
    }
  );
};

export const makeGetActiveSubAreas = () => {
  return createSelector(
    [makeGetActiveAreas(), getSubAreas],
    (activeAreas, subAreas) => {
      const activeAreaIds = activeAreas.map(a => a.id);
      return subAreas.filter(sa => activeAreaIds.includes(sa.area));
    }
  );
};

export const makeGetAllAreas = () => {
  return createSelector(
    [getAllAreas, getDSAAreas],
    (areas, dsaAreas) => {
      let combinedAreas = getCombinedData(areas, dsaAreas, 'area');
      let sortedAreas = combinedAreas.sort((a, b) => a.order - b.order);
      return sortedAreas;
    }
  );
};

export const makeGetIsActiveArea = () => {
  return createSelector(
    [getArea, getDSAAreas],
    (area, dsaAreas) => {
      let activeAreaIds = getActiveAreaIds(dsaAreas);
      return activeAreaIds.indexOf(area.id) >= 0;
    }
  );
};//


const getActiveAreaIds = (dsaAreas) => dsaAreas.map(a => a.active ? a.area : null).filter(a => a);



// WEBPACK FOOTER //
// ./src/selectors/dsa/areaSelectors.js